(function () {
  'use strict';

  var nav = document.querySelector('nav.breadcrumbs[data-hier-type]');
  if (!nav) return;
  var list = nav.querySelector('ol.breadcrumbs-list');
  if (!list) return;

  var type = nav.getAttribute('data-hier-type');
  var handles = (nav.getAttribute('data-hier-handles') || '').split(',').filter(Boolean);
  var shop = (nav.getAttribute('data-hier-shop') || location.origin).replace(/\/$/, '');
  if (!handles.length) return;

  function handleOf(url) {
    var m = /\/collections\/([^/?#]+)/.exec(url || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Recorre el arbol del mega menu y guarda, por coleccion, su ruta desde el nivel superior.
  function indexTree(items, trail, map) {
    (items || []).forEach(function (it) {
      var node = { name: it.name, url: it.url };
      var path = trail.concat(node);
      var h = handleOf(it.url);
      if (h && (!map[h] || map[h].length < path.length)) map[h] = path;
      indexTree(it.items, path, map);
      if (it.menu) indexTree(it.menu.items, path, map);
    });
  }

  function resolvePath(data) {
    var map = {};
    indexTree(data && data.navigationItems, [], map);
    var best = null;
    handles.forEach(function (h) {
      if (map[h] && (!best || map[h].length > best.length)) best = map[h];
    });
    return best;
  }

  function render(path) {
    var items = list.querySelectorAll(':scope > li');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var lastLink = last.querySelector('a');
    if (!lastLink) return;

    var root = (window.MeteorMenu && window.MeteorMenu.localeRootPath) || '/';
    root = root.replace(/\/$/, '');

    // Todo lo que hay tras el enlace de "Inicio" es el divisor (icono).
    var dividerNodes = [];
    var seenLink = false;
    first.childNodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'A') { seenLink = true; return; }
      if (seenLink) dividerNodes.push(n);
    });

    var crumbs = path.map(function (n) {
      return { name: n.name, href: /^https?:/.test(n.url) ? n.url : root + n.url };
    });
    var title = lastLink.textContent.trim();
    var href = lastLink.getAttribute('href');

    if (type === 'collection') {
      // La ultima miga es la propia coleccion, con su titulo real.
      crumbs.pop();
    }
    crumbs.push({ name: title, href: href, current: true });

    // Si el producto ya mostraba una coleccion intermedia, se sustituye por la jerarquia completa.
    var keepFirst = first.cloneNode(true);
    while (list.firstChild) list.removeChild(list.firstChild);
    list.appendChild(keepFirst);

    crumbs.forEach(function (c, i) {
      var li = document.createElement('li');
      li.className = 'flex items-center';
      var a = document.createElement('a');
      a.className = 'breadcrumbs-list__link';
      a.href = c.href;
      a.textContent = c.name;
      li.appendChild(a);
      if (c.current) {
        a.setAttribute('aria-current', 'page');
      } else {
        li.appendChild(document.createTextNode(' '));
        dividerNodes.forEach(function (n) { li.appendChild(n.cloneNode(true)); });
      }
      list.appendChild(li);
    });

    var ld = document.getElementById('breadcrumb-jsonld');
    if (ld) {
      var homeLink = first.querySelector('a');
      var all = [{ name: homeLink ? homeLink.textContent.trim() : 'Inicio', href: homeLink ? homeLink.getAttribute('href') : '/' }].concat(crumbs);
      var json = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: all.map(function (c, i) {
          return {
            '@type': 'ListItem',
            position: i + 1,
            name: c.name,
            item: /^https?:/.test(c.href) ? c.href : shop + c.href
          };
        })
      };
      ld.textContent = JSON.stringify(json);
    }
  }

  function start() {
    var url = window.MeteorMenu && window.MeteorMenu.revisionFileUrl;
    if (!url) return;
    if (url.indexOf('//') === 0) url = location.protocol + url;
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var path = data && resolvePath(data);
        if (path) render(path);
      })
      .catch(function () {});
  }

  start();
})();
